import EventBus from '@js/franchise_component/common/event-bus';
<template lang="pug">
div
    .dker.p-a-md
        .row
            .col-md-4.col-lg-4

            .col-md-4.col-lg-4.text-center(v-show='count > 0')
                .inline
                    .form-group.form-inline
                        label
                            | Record per Page :
                        select.form-control(
                            name='limit',
                            v-model='limit',
                            @change='setLimit'
                        )
                            option(
                                v-for='option in limitOption',
                                :value='option'
                            ) {{ option }}

            .col-md-4.col-lg-4.text-right.text-center-xs(v-show='count > 0')
                .btn-group
                    button.btn.btn-sm.btn-outline(type='button', style='font-weight: 400;') Showing {{ formattedNumber(startCount) }} to {{ formattedNumber(endCount) }} of {{ formattedNumber(totalRecords) }} records

                    button.btn.btn-default.btn-sm(type='button', @click='prev', :disabled='isLoading || !beforeKey.length') &lt;

                    button.btn.btn-default.btn-sm.m-l-xs(
                        type='button',
                        :disabled='!(count >= limit && afterKey) || isLoading',
                        @click='next'
                    ) &gt;
</template>

<script>
export default {
    props: {
        limitOption: {
            type: Array,
            required: false,
            default() {
                return [20, 50, 100];
            },
        },

        count: {
            type: Number,
            required: false,
            default: 0,
        },

        totalRecords: {
            type: Number,
            required: false,
            default: 0,
        },

        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            beforeKey: [],
            afterKey: null,
            limit: this.limitOption[0],
        };
    },

    computed: {
        endCount() {
            return this.startCount + this.count - 1;
        },

        startCount() {
            if (this.beforeKey.length > 0) {
                return this.limit * this.beforeKey.length + 1;
            }
            return 1;
        },
    },

    mounted() {
        this.$on('reset-es-pagination', () => {
            this.afterKey = null;
            this.beforeKey = [];
        });
    },

    methods: {
        next() {
            this.beforeKey.push(this.afterKey);
            this.$emit('navigate', this.afterKey);
        },

        prev() {
            this.afterKey = this.beforeKey[this.beforeKey.length - 2];
            this.beforeKey.pop();
            this.$emit('navigate', this.afterKey);
        },

        setLimit() {
            this.$emit('limit-change', this.limit);
        },

        formattedNumber(val) {
            return numeral(val).format('0,0');
        },
    },
};
</script>

<style lang="scss">
.pagination {
    margin-top: 0;
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/es-table-pagination.vue